import {pathOr} from 'ramda';

import {LOCALES} from '@/src/app/constants/locales';
import {ROLES_NAMES} from '@/src/app/constants/roles';
import {USER_STATUSES} from '@/src/app/constants/userStatuses';

import getRootServerUrl from './getRootServerUrl';

const transformUserData = (user, locale = LOCALES.EN) => {
  const isClinic = user.user.type === ROLES_NAMES.CLINIC;

  const isRequestedToBeDeleted =
    pathOr('', ['user', 'status'], user) === USER_STATUSES.REQUESTED_TO_REMOVE;

  const name = isClinic
    ? pathOr('', ['clinic', 'organization_name'], user)
    : `${pathOr('', ['user', 'first_name'], user)} ${pathOr(
        '',
        ['user', 'last_name'],
        user
      )}`;

  const slug = isClinic
    ? pathOr('', ['clinic', 'slug'], user)
    : pathOr('', ['user', 'username'], user);

  const clinicImage = user?.clinic?.picture
    ? `${getRootServerUrl()}/${pathOr('', ['clinic', 'picture'], user)}`
    : null;
  const userImage = user?.profile?.picture
    ? `${getRootServerUrl()}/${pathOr('', ['profile', 'picture'], user)}`
    : null;

  const profileImage = isClinic ? clinicImage : userImage;

  return {
    name,
    slug,
    id: pathOr('', ['user', 'id'], user),
    clinicId: pathOr('', ['clinic', 'id'], user),
    isFollowed: pathOr(false, ['is_followed'], user),
    type: pathOr('', ['user', 'type'], user),
    courseCount: pathOr(0, ['approved_courses_count'], user),

    rating: pathOr(0, ['average_score'], user),
    image: isRequestedToBeDeleted ? null : profileImage,
    about: pathOr('', ['profile', 'biography'], user),
    company: pathOr('', ['profile', 'employee'], user),
    prefixedAcademicTitle: pathOr(
      '',
      ['profile', 'prefixed_academic_title'],
      user
    ),
    suffixedAcademicTitle: pathOr(
      '',
      ['user', 'profile', 'suffixed_academic_title'],
      user
    ),
    jobTitle: pathOr('', ['professional_experience', 'job_title'], user),
    cityName: pathOr('', ['profile', 'city', `name_${locale}`], user),
    countryName: pathOr('', ['profile', 'country', `name_${locale}`], user),
    biographySanitized: pathOr('', ['profile', 'biography_sanitize'], user),
    isOpenForJob: pathOr(false, ['profile', 'open_for_job'], user),
  };
};

export default transformUserData;
